import React from 'react';
import { Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';

const OpenInvoicesAlert = ({ unpaidInvoices, onClose }) => (
  <div style={{ display: 'flex', alignItems: 'center', minHeight: '40px', position: 'relative' }}>
    <Typography
      variant="body1"
      sx={{
        fontSize: '1rem',
        fontWeight: 'bold',
        textAlign: 'center',
        paddingRight: '50px', // Add padding to prevent text overlap with close button
      }}
    >
      Reminder: You have an open invoice due by {''}
      {unpaidInvoices
        ?.filter((invoice) => invoice.status === 'open')
        ?.map((invoice) => dayjs.unix(invoice.due_date).format('DD-MM-YYYY'))
        .join(', ')}
      . Please make the payment to avoid service disruptions.
    </Typography>
    <IconButton
      aria-label="close"
      color="inherit"
      size="small"
      onClick={onClose}
      sx={{
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)',
      }}
    >
      <CloseIcon />
    </IconButton>
  </div>
);

export default OpenInvoicesAlert;
